











































import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import { State } from "vuex-class";
import { Profile } from "@foxone/api/src/models/account";
import MixinAccount from "basis/components/profile/MixinAccount.vue";
import FoxAccount from "basis/components/profile/FoxAccount.vue";

@Component({
  components: {
    MixinAccount,
    FoxAccount
  }
})
class ProfilePage extends Mixins(mixins.page) {
  @State(state => state.basis.account.profile) profile!: Profile;

  get title() {
    return this.$t("common.account-security") as string;
  }

  get meta() {
    const profile = this.profile || {};
    const foxone = profile.foxone;
    const mixin = profile.mixin;
    const foxoneMigrateRequired = profile.foxone_migrate_required;
    const isFoxBind = !foxoneMigrateRequired && foxone;
    const foxonePhoneNumber =
      (foxone && "+" + foxone.phone_code + " " + foxone.phone_number) || "";
    return {
      name: mixin?.full_name ?? "",
      avatar: profile.avatar_url,
      isPhoneBind: profile.is_phone_bind,
      phone: "+" + profile.phone_code + " " + profile.phone_number,
      isMixinBind: profile.is_mixin_bind,
      mixin,
      foxone,
      isFoxBind,
      foxonePhoneNumber,
      foxoneMigrateRequired
    };
  }

  handleLogout() {
    this.$common.utils.helper.requestLogout(this);
  }

  handleToLoginPage() {
    this.$common.utils.helper.requestToLoginPage(this);
  }
}
export default ProfilePage;
